export const editPath = "<path d=\"M11.2 3.3 L12.7 4.8 L6 11.5 L3.5 12.5 L4.5 10 Z\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/>"
